<template>
  <div>
    <WizardDetailWrapper
      :class="['tw-mb-[25px]']"
      :title="item.title"
      :show-accordion="item.showAccordion"
      :show-question="false"
      :data="data"
      :page-active="idPage.brandsPage"
      :validation="v$.brandName"
      :show-validate-now="true"
      :is-api-error="statusInPageClone"
      @input="updateStore(item, currentIndex)"
    >
      <template #title>
        <div style="position: relative; width: 100%">
          <input
            v-model="item.brandName"
            class="enter__name"
            :placeholder="
              getComponentUiText(
                'app-menu-submenu-home-setup-wizard-brand-name-prompt-1',
              )
            "
            style="border: unset; background-color: unset"
            @click.stop
          />
          <span
            v-if="!item.brandName"
            style="position: absolute; left: 130px; top: -3px; color: red"
            >*</span
          >
        </div>
      </template>
      <MoreDetails
        v-if="isMoreDetails"
        :classes-more-detail="'!tw-p-0'"
        :is-show-questions="false"
      />
    </WizardDetailWrapper>
  </div>
</template>

<script setup lang="ts">
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { Ref, ref, computed, onMounted, reactive, watch } from "vue";
import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import MoreDetails from "./moreDetails.vue";
import { getComponentUiText } from "@/utils/utilities";
import { idWizardPage as idPage, statusPage } from "@/utils/constants";

import store from "@/store";
const isMoreDetails = ref(false);
const currentOrg = computed(() => store.state.Org.currentOrg);
onMounted(() => {
  store.commit("SetupWizard/SET_CURRENT_ORG", currentOrg.value.id);
});
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  currentIndex: {
    type: Number,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});
const item = ref(props.item);
watch(
  () => props.item,
  (newVal) => {
    item.value = newVal;
  },
);
const accordionNumber = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (
    setupWizard.questions[currentOrg.value.id]?.brands[0]?.values.length > 0
  ) {
    return setupWizard.questions[currentOrg.value.id].brands[0].values.map(
      (el) => ({
        ...el,
        showAccordion: false,
      }),
    );
  } else {
    return [];
  }
});

const bodyAPIError = computed(() => {
  if (
    !item.value.id &&
    props.statusInPage.dataError.length > 0 &&
    item.value.isCallAPI
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError.find((i) => i.id === item.value.id)
  );
});

const statusInPageClone = ref(bodyAPIError);

const rules = {
  brandName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
const v$ = useVuelidate(rules, item as any);
const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  return !v$.value.$error;
};
defineExpose({
  saveChanges,
});
const emits = defineEmits(["changeStatusAddBrand"]);
const updateStore = (item, index) => {
  store.commit("SetupWizard/SET_BRAND_NAME", {
    value: item,
    _index: index,
    currentOrg: currentOrg.value.id,
  });
  emits("changeStatusAddBrand", true);
};
</script>
<style scoped>
::placeholder {
  color: #b7b7b7;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
}
.enter__name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  font-family: Poppins;
  color: #211f58;
  width: 98%;
}
::-ms-input-placeholder {
  color: red;
}
@media screen and (max-width: 590px) {
  .enter__name {
    width: 100%;
  }
}
</style>
